module.exports = __webpack_public_path__ + "static/media/Up.b48d6133.svg";